'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteTemplateIfNeeded = exports.deleteTemplateFailure = exports.deleteTemplateSuccess = exports.deleteTemplateRequest = exports.DELETE_TEMPLATE_FAILURE = exports.DELETE_TEMPLATE_SUCCESS = exports.DELETE_TEMPLATE_REQUEST = exports.postTemplateIfNeeded = exports.postTemplateFailure = exports.postTemplateSuccess = exports.postTemplateRequest = exports.POST_TEMPLATE_FAILURE = exports.POST_TEMPLATE_SUCCESS = exports.POST_TEMPLATE_REQUEST = exports.fetchTemplatesIfNeeded = exports.failureTemplates = exports.receiveTemplates = exports.requestTemplates = exports.invalidateTemplates = exports.filterTemplates = exports.INVALIDATE_TEMPLATES = exports.FILTER_TEMPLATES = exports.FAILURE_TEMPLATES = exports.RECEIVE_TEMPLATES = exports.REQUEST_TEMPLATES = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 模版相关Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_TEMPLATES = exports.REQUEST_TEMPLATES = 'REQUEST_TEMPLATES';
var RECEIVE_TEMPLATES = exports.RECEIVE_TEMPLATES = 'RECEIVE_TEMPLATES';
var FAILURE_TEMPLATES = exports.FAILURE_TEMPLATES = 'FAILURE_TEMPLATES';
var FILTER_TEMPLATES = exports.FILTER_TEMPLATES = 'FILTER_TEMPLATES';
var INVALIDATE_TEMPLATES = exports.INVALIDATE_TEMPLATES = 'INVALIDATE_TEMPLATES';

var filterTemplates = exports.filterTemplates = function filterTemplates(filter) {
    return {
        type: FILTER_TEMPLATES,
        filter: filter
    };
};

var invalidateTemplates = exports.invalidateTemplates = function invalidateTemplates(filter) {
    return {
        type: INVALIDATE_TEMPLATES,
        filter: filter
    };
};

var requestTemplates = exports.requestTemplates = function requestTemplates(filter) {
    return {
        type: REQUEST_TEMPLATES,
        filter: filter
    };
};

var receiveTemplates = exports.receiveTemplates = function receiveTemplates(filter, json) {
    var templates = json.data.map(function (x) {
        return _extends({}, x, {
            title: x.title,
            subTitle: x.sub_title,
            sort: x.default_order,
            type: {
                id: x.product_type.product_type_id,
                name: x.product_type.name
            },
            thumb: x.default_image.url,
            id: x.template_id,
            defaultImage: x.default_image ? { id: x.default_image.upload_id, url: x.default_image.url } : undefined
        });
    });

    return {
        type: RECEIVE_TEMPLATES,
        filter: filter,
        templates: templates,
        pagination: json.meta.pagination,
        received_at: Date.now()
    };
};
var failureTemplates = exports.failureTemplates = function failureTemplates(error) {
    return {
        type: FAILURE_TEMPLATES,
        error: error
    };
};

var shouldFetchTemplates = function shouldFetchTemplates(state, filter) {
    var templates = state.template.templates;
    if (templates.items.length === 0) {
        return true;
    }
    if (templates.isFetching) {
        return false;
    }
    // return templates.didInvalidate
    return true;
};

var fetchTemplatesIfNeeded = exports.fetchTemplatesIfNeeded = function fetchTemplatesIfNeeded(filter) {
    return function (dispatch, getState) {
        if (shouldFetchTemplates(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestTemplates(filter));
                return (0, _api.fetchTemplates)(filter).then(function (response) {
                    return dispatch(receiveTemplates(filter, response.data));
                }, function (error) {
                    return dispatch(failureTemplates(error));
                });
            });
        }
    };
};

/**
 * 提交模版相关
 *
 */
var POST_TEMPLATE_REQUEST = exports.POST_TEMPLATE_REQUEST = 'POST_TEMPLATE_REQUEST';
var POST_TEMPLATE_SUCCESS = exports.POST_TEMPLATE_SUCCESS = 'POST_TEMPLATE_SUCCESS';
var POST_TEMPLATE_FAILURE = exports.POST_TEMPLATE_FAILURE = 'POST_TEMPLATE_FAILURE';

var postTemplateRequest = exports.postTemplateRequest = function postTemplateRequest() {
    return {
        type: POST_TEMPLATE_REQUEST
    };
};

var postTemplateSuccess = exports.postTemplateSuccess = function postTemplateSuccess(response) {
    return {
        type: POST_TEMPLATE_SUCCESS,
        received_at: Date.now()
    };
};
var postTemplateFailure = exports.postTemplateFailure = function postTemplateFailure(error) {
    return {
        type: POST_TEMPLATE_FAILURE,
        error: error
    };
};

var shouldPostTemplate = function shouldPostTemplate(state) {
    var templates = state.template.templates;
    if (templates.isPosting) {
        return false;
    }
    return true;
};

var postTemplateIfNeeded = exports.postTemplateIfNeeded = function postTemplateIfNeeded(values, router) {
    return function (dispatch, getState) {
        if (shouldPostTemplate(getState())) {
            return dispatch(function (dispatch) {
                dispatch(postTemplateRequest());
                return (0, _api.postTemplate)(values).then(function (response) {
                    _message2.default.success('提交成功');
                    router.push('/templates'); // 二话不说 直接跳转
                    dispatch(fetchTemplatesIfNeeded());
                    return dispatch(postTemplateSuccess(response));
                }).catch(function (error) {
                    _message2.default.error('提交失败');
                    dispatch(postTemplateFailure(error));
                });
            });
        }
    };
};

/**
 * 删除模版相关
 */
var DELETE_TEMPLATE_REQUEST = exports.DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
var DELETE_TEMPLATE_SUCCESS = exports.DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
var DELETE_TEMPLATE_FAILURE = exports.DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';
var deleteTemplateRequest = exports.deleteTemplateRequest = function deleteTemplateRequest() {
    return {
        type: DELETE_TEMPLATE_REQUEST
    };
};

var deleteTemplateSuccess = exports.deleteTemplateSuccess = function deleteTemplateSuccess(response) {
    return {
        type: DELETE_TEMPLATE_SUCCESS,
        received_at: Date.now()
    };
};
var deleteTemplateFailure = exports.deleteTemplateFailure = function deleteTemplateFailure(error) {
    return {
        type: DELETE_TEMPLATE_FAILURE,
        error: error
    };
};

var shouldDeleteTemplate = function shouldDeleteTemplate(state) {
    var templates = state.template.templates;
    if (templates.isDeleting) {
        return false;
    }
    return true;
};

var deleteTemplateIfNeeded = exports.deleteTemplateIfNeeded = function deleteTemplateIfNeeded(id, router) {
    return function (dispatch, getState) {
        if (shouldDeleteTemplate(getState())) {
            return dispatch(function (dispatch) {
                dispatch(deleteTemplateRequest());
                return (0, _api.deleteTemplate)(id).then(function (response) {
                    _message2.default.success('删除成功');
                    router.push('/templates'); // 二话不说 直接跳转
                    dispatch(fetchTemplatesIfNeeded());
                    return dispatch(deleteTemplateSuccess(response));
                }).catch(function (error) {
                    if (error && error.response && error.response.data) {
                        _message2.default.error(error.response.data.message);
                    }
                    dispatch(deleteTemplateFailure(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/template.js
// module id = 880
// module chunks = 0